import React, { useEffect, useState, useRef, useCallback } from "react";
import Items from "../Items/Items";
import { Link } from "react-router-dom";
// import data from "../../../data";
import productData from "../../../data";
import category from "../../../category";
import brand from "../../../brand";
import size from "../../../size";
import colors from "../../../colors";
import Single from "../SingleProduct/Single";
import ProductsDisplayed from "../ItemDisplayed/ProductsDisplayed";
import FilterSide from "../FilterSide/FilterSide";
import CheckBox from "../Checkbox/CheckBox";
// import products from "../../../data";
const Products = (props) => {
  const initFilter = {
    category: [],
    color: [],
    size: [],
    brand: [],
  };

  const productList = productData.getAllProducts();

  const [products, setProducts] = useState(productList);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [filter, setFilter] = useState(initFilter);

  const filterSelect = (type, checked, item) => {
    if (checked) {
      switch (type) {
        case "CATEGORY":
          setFilter({
            ...filter,
            category: [...filter.category, item.categorySlug],
          });
          break;
        case "BRAND":
          setFilter({
            ...filter,
            brand: [...filter.brand, item.brandSlug],
          });
          break;
        case "COLOR":
          setFilter({ ...filter, color: [...filter.color, item.color] });
          break;
        case "SIZE":
          setFilter({ ...filter, size: [...filter.size, item.size] });
          break;
        default:
      }
    } else {
      switch (type) {
        case "CATEGORY":
          const newCategory = filter.category.filter(
            (e) => e !== item.categorySlug
          );
          setFilter({ ...filter, category: newCategory });
          break;
        case "COLOR":
          const newColor = filter.color.filter((e) => e !== item.color);
          setFilter({ ...filter, color: newColor });
          break;
        case "SIZE":
          const newSize = filter.size.filter((e) => e !== item.size);
          setFilter({ ...filter, size: newSize });
          break;
        case "BRAND":
          const newBrand = filter.brand.filter((e) => e !== item.brandSlug);
          setFilter({ ...filter, brand: newBrand });
          break;
        default:
      }
    }
  };

  const clearFilter = () => setFilter(initFilter);

  const updateProducts = useCallback(() => {
    let temp = productList;

    if (filter.category.length > 0) {
      temp = temp.filter((e) => filter.category.includes(e.categorySlug));
    }

    if (filter.brand.length > 0) {
      temp = temp.filter((e) => filter.brand.includes(e.brandSlug));
    }

    if (filter.color.length > 0) {
      temp = temp.filter((e) => {
        const check = e.colors.find((color) => filter.color.includes(color));
        return check !== undefined;
      });
    }

    if (filter.size.length > 0) {
      temp = temp.filter((e) => {
        const check = e.size.find((size) => filter.size.includes(size));
        return check !== undefined;
      });
    }

    setProducts(temp);
  }, [filter, productList]);

  useEffect(() => {
    updateProducts();
  }, [updateProducts]);

  const filterRef = useRef(null);

  const showHideFilter = () => filterRef.current.classList.toggle("active");
  console.log("category", category);

  return (
    <section className="content-area products-all-page" ref={filterRef}>
      {/* ======== */}

      <div className="filter-section">
        <div className="filter">
          <input type="checkbox" id="category-options" className="toggle" />
          <label className="title" htmlFor="category-options">
            Category
          </label>
          <div className="content">
            <div className="category">
              {category.map((item, index) => (
                <div key={index}>
                  <CheckBox
                    label={item.display}
                    onChange={(input) =>
                      filterSelect("CATEGORY", input.checked, item)
                    }
                    checked={filter.category.includes(item.categorySlug)}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="filter">
          <input type="checkbox" id="brand-options" className="toggle" />
          <label className="title" htmlFor="brand-options">
            Brand
          </label>
          <div className="content">
            <div className="brand">
              {brand.map((item, index) => (
                <div key={index}>
                  <CheckBox
                    label={item.display}
                    onChange={(input) =>
                      filterSelect("BRAND", input.checked, item)
                    }
                    checked={filter.brand.includes(item.brandSlug)}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* <div className="filter">
          <input type="checkbox" id="price-options" className="toggle" />
          <label className="title" htmlFor="price-options">
            Price
          </label>
          <div className="content">
            <div className="price">
              <input
                type="text"
                name="min"
                placeholder="min"
                className="option"
              />
              <input
                type="text"
                name="max"
                placeholder="max"
                className="option"
              />
            </div>
          </div>
        </div> */}

        <div className="filter">
          <input type="checkbox" id="size-options" className="toggle" />
          <label className="title" htmlFor="size-options">
            Size
          </label>
          <div className="content">
            <div className="size">
              {size.map((item, index) => (
                <div key={index}>
                  <CheckBox
                    label={item.display}
                    onChange={(input) =>
                      filterSelect("SIZE", input.checked, item)
                    }
                    checked={filter.size.includes(item.size)}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        <button onClick={() => clearFilter()}>Clear Filter</button>
      </div>

      {/* ======== */}
      <div className="all-products-grid">
        {products.map((product, index) => (
          <ProductsDisplayed product={product} key={index} />
        ))}
      </div>
    </section>
  );
};

export default Products;

// {products.map((product) => (
//   <div className="product-wrap">
//     <div className="product">
//       <div className="circle">
//         <img src={product.image_url} />
//       </div>
//     </div>

//     <div className="title">{product.title}</div>
//     <div className="price">${product.price}</div>
//   </div>
// ))}
